import React from 'react';
import { Icon, Icons, Tooltip } from '@silverfort/sf-components';

interface Props {
    name: string;
    showIcon?: boolean;
}

const ExposureNameColumn: React.FC<Props> = ({ name, showIcon }) => {
    return (
        <div className="flex justify-between items-center gap-2">
            <Tooltip title={name}>
                <h3 className="text-sm truncate min-w-52 w-52">{name}</h3>
            </Tooltip>
            {showIcon && (
                <Tooltip title="Alert threshold can be customized in this exposure">
                    <span className="rounded-full flex items-center justify-center">
                        <Icon icon={Icons.CircleInfo}  size={18} />
                    </span>
                </Tooltip>
            )}
        </div>
    );
};

export default ExposureNameColumn;
